<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-user-circle"></i> My Account</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <strong>My Account</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                    </div>
                </div>
            </div>
        </div>

        <div class="email-app">
            <div class="left-part">
                <div class="scrollable" style="height:100%;">
                    <div class="p-15">
                        <router-link class="waves-effect waves-light text-white btn btn-success d-block" to="/mailbox/compose">Compose</router-link>
                    </div>
                    <div class="divider"></div>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <router-link :to="{name: 'inbox'}" class="active list-group-item-action">
                                <i class="mdi mdi-inbox"></i> Inbox
                            </router-link>
                        </li>
                        <li class="list-group-item">
                            <router-link :to="{name: 'draft'}" class="list-group-item-action">
                                <i class="mdi mdi-pencil"></i> Drafts
                            </router-link>
                        </li>
                        <li class="list-group-item">
                            <router-link :to="{name: 'sent'}" class="list-group-item-action">
                                <i class="mdi mdi-email"></i> Sent Mail
                            </router-link>
                        </li>
                        <li class="list-group-item">
                            <hr>
                        </li>
                        <!-- <li class="list-group-item">
                            <a href="javascript:void(0)" class="list-group-item-action"> <i class="mdi mdi-delete"></i> Trash </a>
                        </li>
                        <li class="list-group-item">
                            <hr>
                        </li> -->
                    </ul>
                </div>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MailboxLayout"
    }
</script>

<style scoped>

</style>
